import { Component, Input } from '@angular/core';
import { UiPillStatusEnum } from 'src/app/shared/enums/ui-pill-status.enum';

@Component({
  selector: 'app-read-receipt-template',
  templateUrl: './read-receipt-template.component.html',
  styleUrls: ['./read-receipt-template.component.scss'],
  standalone: false,
})
export class ReadReceiptTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  status = UiPillStatusEnum;

  getReadReceiptStatusPillClass(row: { status?: string }): string {
    const key = String(row?.status ?? '').toLowerCase();
    if (key === 'pending') {
      return this.status.Expiring;
    }
    if (key === 'read') {
      return this.status.Ok;
    }
    if (key === 'cancelled') {
      return this.status.Deactivated;
    }
    return this.status.Pending;
  }
}
